export const PROMPTS_PER_PAGE = 3;

export const MI_SUGGESTED_PROMPTS = [
  'How have Pulp prices changed in the last 6 months?',
  'What is the forecast of BHKP Pulp?',
  'Have OCC prices been volatile recently?',
];

export const KM_SUGGESTED_PROMPTS = [
  'How do I submit a business case in productivity framework?',
  'Can I report productivity from 5 years ago',
  'Who can approve productivity initiatives',
  'How should Bill & Hold be handled?',
  'There is an evergreen contract from 2012, is this okay?',
  'Do Utilities contracts need Supplier Code of Conduct?',
];

export const LAST_REFRESHED_LABEL_MAP = {
  procurement_policy: 'Procurement Policy',
  productivity_framework: 'Productivity Framework',
  price: "Price",
  news: "News",
};
